import { useAuth } from '@clerk/clerk-react';
import { useMemo } from 'react';
import { createApi, type Api } from '@/api/client';
import { useImpersonation } from '@/hooks/useImpersonation';

/**
 * React hook that returns an API client bound to the current Clerk session.
 * When an admin is impersonating an outreacher, the `x-impersonate-inviter`
 * header is automatically attached to every request.
 */
export function useApi(): Api {
  const { getToken } = useAuth();
  const { inviterId } = useImpersonation();
  return useMemo(() => {
    const extraHeaders: Record<string, string> | undefined = inviterId
      ? { 'x-impersonate-inviter': String(inviterId) }
      : undefined;
    return createApi(() => getToken(), extraHeaders);
  }, [getToken, inviterId]);
}
